import React, { useState, useEffect, useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'

import { InstagramPost } from '../InstagramCarousel'
import Link from '@atoms/Link'
import Instagram from '@icons/Instagram'

import * as style from './style.module.sass'

export type InstagramCarouselTabNewProps = {
  posts: InstagramPost[]
}

const InstagramCarouselTabNew: React.FC<InstagramCarouselTabNewProps> = ({
  posts,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
    },
    [],
  )

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)

    emblaApi.on('reInit', onSelect)
    emblaApi.on('select', onSelect)
  }, [emblaApi, onSelect])

  const media = (
    mediaUrl: InstagramPost['mediaUrl'],
    mediaType: InstagramPost['mediaType'],
    caption: InstagramPost['caption'],
  ) => {
    // keyは毎回表示の際に発生するアニメーションのために必要
    return (
      <>
        {mediaType === 'VIDEO' ? (
          <video autoPlay muted loop playsInline key={mediaUrl}>
            <source src={mediaUrl} type="video/mp4" />
          </video>
        ) : (
          <img src={mediaUrl} alt={caption} key={mediaUrl} />
        )}
      </>
    )
  }

  if (!posts.length) return null

  return (
    <div className={style.container}>
      <div className={style.detailed}>
        <Link to={posts[selectedIndex].permalink}>
          {media(
            posts[selectedIndex].mediaUrl,
            posts[selectedIndex].mediaType,
            posts[selectedIndex].caption,
          )}
        </Link>
        <div className={style.caption}>{posts[selectedIndex].caption}</div>
      </div>
      <div ref={emblaRef} className={style.carouselContainer}>
        <div className={style.carousel}>
          {posts.map(({ mediaUrl, mediaType, caption }, index: number) => (
            <button
              className={style.item}
              key={index}
              onClick={() => {
                emblaApi?.scrollTo(index)
              }}
              data-selected={index === selectedIndex}
            >
              {media(mediaUrl, mediaType, caption)}
            </button>
          ))}
        </div>
        <Link
          to="https://www.instagram.com/ftn_artisan/"
          className={style.instagram}
        >
          <Instagram />
          @FTN_Artisan
        </Link>
      </div>
    </div>
  )
}

export default InstagramCarouselTabNew
